import { useQuery, useSubscription } from "@apollo/react-hooks";
import { useMyHrUserRolesDataByContract } from "my-hr/hooks";
import {
  MY_LEAVE_GET_BADGES,
  MY_LEAVE_REQUESTS_SUBSCRIPTION,
} from "my-leave/graphql";
import { useOcCurrentUserState } from "oc/hooks";

export const useMyLeaveBadges = (userType = "examiner") => {
  let { contractCode } = useOcCurrentUserState();

  const { hasRole } = useMyHrUserRolesDataByContract({
    contract: contractCode,
  });

  let allowedRoles = ["MyLeave.examiner"];
  if (userType !== "examiner") {
    allowedRoles = ["MyLeave.examiner", "MyLeave.viewer"];
  }
  let notAllowedRoles: string[] = [];

  let hasRight = hasRole(allowedRoles, notAllowedRoles);

  const { data, loading, error, refetch } = useQuery(MY_LEAVE_GET_BADGES, {
    skip: !contractCode || !hasRight,
    fetchPolicy: "cache-and-network",
    variables: { contract: contractCode },
  });

  if (error) {
    console.log({
      component: "useMyLeaveBadges",
      errorDescription:
        "Error occured when fetch data with MY_LEAVE_GET_BADGES query",
      error: error,
    });
  }

  const { error: subscriptionError } = useSubscription(
    MY_LEAVE_REQUESTS_SUBSCRIPTION,
    {
      skip: !contractCode || !hasRight,
      onData: () => {
        refetch();
      },
    },
  );

  if (subscriptionError) {
    console.log({
      component: "useMyLeaveBadges",
      errorDescription:
        "Error occured when subscribe data with MY_LEAVE_REQUESTS_SUBSCRIPTION query",
      error: subscriptionError,
    });
  }

  return {
    data: data?.myLeaveBadges,
    loading: loading || false,
    error: error || undefined,
  };
};

export default useMyLeaveBadges;
